angular.module('qkr').directive('fixFocus', () => ({
		restrict: 'AE',
		link(scope, element) {
			element.bind('keydown keypress', (event) => {
				if ((event.which === 9) || (event.keyCode === 9)) {
					element.parent().parent().next().find('input').focus();
				}
			});
		}
	}));



// WEBPACK FOOTER //
// ./src/directives/fix_focus.js